import BlogTwentyOneContainer from "./container/BlogTwentyOneContainer";
export default BlogTwentyOneContainer;
